import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './FromIdeaToImpact.css';
import missionImg from '../assets/YOCILAB Webiste photos/YOCILAB Home page/About Us/Our Mission (2).png';
import visionImg from '../assets/YOCILAB Webiste photos/YOCILAB Home page/About Us/Vision.png';
import focusImg from '../assets/YOCILAB Webiste photos/YOCILAB Home page/About Us/focus Areas.png';

const FromIdeaToImpact = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    const targets = sectionRef.current?.querySelectorAll('.fade-up, .slide-left, .slide-right');
    targets?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mission-section" ref={sectionRef}>
      {/* Who We Are */}
      <div className="mission-section__who">
        <div className="container">
          <div className="mission-section__who-grid">
            <div className="mission-section__who-text slide-left">
              <span className="section-label">WHO WE ARE</span>
              <h2 className="mission-section__who-title">
                Youth Connect Innovation Lab
              </h2>
              <p className="mission-section__who-body">
                YOCILAB is a youth-led organization dedicated to driving youth employment and inclusive economic development across Africa. We believe that talent is universal — but opportunity is not. We exist to change that.
              </p>
              <p className="mission-section__who-body">
                Through our Academy, Summit, Creative Space, and Ventures ecosystem, we equip young people with the skills, networks, and funding they need to design solutions that create jobs and scale impact.
              </p>
              <Link to="/about/who-are-we" className="mission-section__link">
                Our full story
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>

            <div className="mission-section__who-visual slide-right">
              <div className="mission-section__img-stack">
                <img src={missionImg} alt="YOCILAB Mission" className="mission-section__img mission-section__img--main" loading="lazy" />
                <img src={focusImg} alt="YOCILAB Focus Areas" className="mission-section__img mission-section__img--accent" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pillars */}
      <div className="mission-section__pillars">
        <div className="container">
          <div className="mission-section__pillars-header fade-up">
            <span className="section-label">WHAT DRIVES US</span>
            <h2 className="mission-section__pillars-title">Three pillars of change</h2>
          </div>

          <div className="mission-section__pillars-grid">
            {[
              {
                number: '01',
                title: 'Skills',
                color: 'var(--color-academy)',
                img: missionImg,
                desc: 'We equip young people with practical skills in technology, entrepreneurship, and career readiness — preparing them for the jobs and opportunities of today and tomorrow.',
              },
              {
                number: '02',
                title: 'Networks',
                color: 'var(--color-accent)',
                img: visionImg,
                desc: 'We connect young talent with employers, mentors, investors, and peers — building the relationships that open doors and create lasting opportunity.',
              },
              {
                number: '03',
                title: 'Funding',
                color: 'var(--color-primary)',
                img: focusImg,
                desc: 'Through Seed4Impact and our partners, we provide pathways to funding, incubation, and support for youth-led ventures creating economic and social impact.',
              },
            ].map((p, i) => (
              <div key={p.number} className="pillar-card fade-up" style={{ transitionDelay: `${i * 120}ms` }}>
                <div className="pillar-card__img-wrapper">
                  <img src={p.img} alt={p.title} className="pillar-card__img" loading="lazy" />
                  <div className="pillar-card__overlay" style={{ background: `linear-gradient(to top, ${p.color}DD, transparent)` }} />
                </div>
                <div className="pillar-card__body">
                  <span className="pillar-card__number" style={{ color: p.color }}>{p.number}</span>
                  <h3 className="pillar-card__title">{p.title}</h3>
                  <p className="pillar-card__desc">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FromIdeaToImpact;